const loadMobileMenu = () => {
    const siteNav = document.querySelector('.site-nav')
    const toggle = document.querySelector('.site-nav #toggle')

    toggle.addEventListener('click', function () {
        console.log('clicked')
        if (siteNav.classList.contains('menu-visible')) {
            this.setAttribute('aria-expanded', 'false')
            siteNav.classList.remove('menu-visible')
        } else {
            siteNav.classList.add('menu-visible')
            this.setAttribute('aria-expanded', 'true')
        }
    })
}

export default loadMobileMenu



// WEBPACK FOOTER //
// ./js/mobileMenu.js